<template>
  <FormulateForm ref="formClientTab" name="formClientTab" style="height: 100%">
    <b-container class="tab-container">
      <b-card-actions no-actions :show-loading="isCustomerLoading">
        <b-row align-h="end">
          <b-col md="12">
            <div style="display: flex; justify-content: end; gap: 10px">
              <e-button
                v-if="!isOrder && hasRewardBalance && !hasRewardsApplied"
                id="pdv-tab-client-btn-apply-rewards"
                variant="success"
                :text="`Aplicar desconto ecash ${formatRewardBalance(rewardBalance)}`"
                size="sm"
                @click="applyRewards"
              />
              <e-button
                v-if="!isOrder && hasRewardsApplied"
                id="pdv-tab-client-btn-remove-rewards"
                variant="danger"
                :text="`Remover desconto ecash ${$options.filters.currency(
                  paymentForm.rewardsAmountUsed
                )}`"
                size="sm"
                @click="removeRewards"
              />
              <e-button
                v-if="!(isOrder || hasPalmBeerCustomer)"
                id="pdv-tab-client-btn-clean"
                variant="danger"
                text="Limpar"
                size="sm"
                @click="onCleanForm"
              />
              <e-button
                v-if="existClient && stClientForm.id != 1"
                pill
                class="refresh-button"
                variant="outline-secondary"
                type="button"
                icon="arrow-clockwise"
                :title="$t('Atualizar dados do cliente')"
                style="z-index: 10"
                @click="refreshCustomer"
              />
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="4">
            <FormulateInput
              id="pdv-tab-client-person-type"
              :value="stClientForm.personType"
              name="personType"
              type="label"
              :options="personTypesOptions()"
              :label="$t('Tipo')"
            />
          </b-col>
          <b-col :md="showTefRequestDocument ? '6' : '7'">
            <FormulateInput
              v-if="!existClient && !isDocumentFromTef"
              id="pdv-tab-client-document"
              v-model="stClientForm.document"
              :mask="['###.###.###-##', 'XX.XXX.XXX/XXXX-##']"
              name="document"
              type="text-mask"
              :label="$t('CPF ou CNPJ')"
              :placeholder="$t('CPF ou CNPJ')"
              validation="optional|cpfCnpj"
              :disabled="isOrder || hasPalmBeerCustomer || isCustomerLoading"
              @input="onInputCustomerDocument"
            />
            <FormulateInput
              v-else
              id="pdv-tab-client-document"
              v-model="stClientForm.document"
              name="document"
              type="label"
              :label="$t('CPF ou CNPJ')"
              filter="cpfCnpj"
            />
          </b-col>
          <b-col v-if="showTefRequestDocument" md="2" class="mt-1">
            <e-button
              variant="outline-primary"
              type="button"
              icon="keyboard"
              :title="$t('Solicitar documento com PinPad')"
              :text-shortcuts="['F8']"
              :busy="isCustomerLoading"
              @click="onRequestDocument"
            />
          </b-col>
        </b-row>

        <b-row v-if="!hasCustomer && hasActivePayment">
          <b-col md="12">
            <b-alert show variant="warning" class="p-2">
              {{
                $t(
                  'Se informar um cliente, as vantagens dele não serão aplicadas, pois há pagamentos ativos na venda.'
                )
              }}
              <br />
              <br />
              {{
                $t(
                  'Para aplicar as vantagens, será necessário cancelar os pagamentos ativos e informar o cliente novamente.'
                )
              }}
            </b-alert>
          </b-col>
        </b-row>

        <transition name="fade">
          <div v-if="!isAnonymous">
            <template v-if="isNatural">
              <b-row class="align-items-center">
                <b-col
                  :md="!existClient ? '12' : isUpdating.name ? '8' : 'auto'"
                  class="d-flex align-items-center"
                >
                  <FormulateInput
                    id="pdv-tab-client-name"
                    ref="name"
                    v-model="stClientForm.name"
                    name="name"
                    :type="existClient && !isUpdating.name ? 'label' : 'text'"
                    :validation="stClientForm.id === 1 ? 'optional' : 'optional|fullName'"
                    :label="$t('Nome')"
                    :placeholder="$t('Nome')"
                    class="flex-grow-1"
                  />
                  <e-button
                    v-if="enableEdit('name')"
                    pill
                    class="edit-button ml-2"
                    variant="outline-secondary"
                    type="button"
                    icon="pencil"
                    :title="$t('Alterar \'Nome\' do cliente')"
                    @click="ableToUpdate('name')"
                  />
                </b-col>
                <b-col v-if="isUpdating.name && stClientForm.id" class="actions pf-actions">
                  <e-button
                    title="Confirmar"
                    size="sm"
                    variant="primary"
                    icon="check-circle"
                    style="margin-right: 6px"
                    @click="updateCompanyNameOrName(stClientForm.name, 'name')"
                  />
                  <e-button
                    title="Cancelar"
                    size="sm"
                    variant="danger"
                    icon="x-circle"
                    @click="cancelUpdate('name')"
                  />
                </b-col>
              </b-row>
            </template>

            <template v-if="isJuridical">
              <b-row class="align-items-center">
                <b-col
                  :md="!existClient ? '12' : isUpdating.companyName ? '8' : 'auto'"
                  class="d-flex align-items-center"
                >
                  <FormulateInput
                    id="pdv-tab-client-company-name"
                    ref="companyName"
                    v-model="stClientForm.companyName"
                    name="corporateName"
                    :type="existClient && !isUpdating.companyName ? 'label' : 'text'"
                    :validation="stClientForm.id === 1 ? 'optional' : 'optional|fullName'"
                    :label="$t('Razão social')"
                    :placeholder="$t('Razão Social')"
                    class="flex-grow-1"
                  />
                  <e-button
                    v-if="enableEdit('companyName')"
                    pill
                    class="edit-button ml-2"
                    variant="outline-secondary"
                    type="button"
                    icon="pencil"
                    @click="ableToUpdate('companyName')"
                  />
                </b-col>
                <b-col v-if="isUpdating.companyName && stClientForm.id" class="actions pf-actions">
                  <e-button
                    title="Confirmar"
                    size="sm"
                    variant="primary"
                    icon="check-circle"
                    style="margin-right: 6px"
                    @click="updateCompanyNameOrName(stClientForm.companyName, 'companyName')"
                  />
                  <e-button
                    title="Cancelar"
                    size="sm"
                    variant="danger"
                    icon="x-circle"
                    @click="cancelUpdate('companyName')"
                  />
                </b-col>
              </b-row>
            </template>

            <b-row>
              <b-col>
                <FormulateInput
                  id="pdv-tab-client-email"
                  v-model="stClientForm.email"
                  name="email"
                  :type="existClient ? 'label' : 'text'"
                  validation="optional|email"
                  :filter="existClient ? 'emailMask' : null"
                  :label="$t('E-mail')"
                  :placeholder="$t('exemplo@email.com')"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <FormulateInput
                  v-if="!existClient"
                  id="pdv-tab-client-phone-landline"
                  v-model="stClientForm.landLine"
                  v-mask="'(##) ####-####'"
                  :placeholder="$t('(99) 9999-9999')"
                  name="phone"
                  type="text"
                  :label="$t('Telefone')"
                />
                <FormulateInput
                  v-else
                  id="pdv-tab-client-phone-landline"
                  :value="stClientForm.landLine"
                  name="phone"
                  type="label"
                  :label="$t('Telefone')"
                  filter="phone"
                />
              </b-col>
              <b-col>
                <FormulateInput
                  v-if="!existClient"
                  id="pdv-tab-client-phone-mobile"
                  v-model="stClientForm.mobilePhone"
                  v-mask="'(##) #####-####'"
                  :placeholder="$t('(99) 99999-9999')"
                  name="cellphone"
                  :type="existClient ? 'label' : 'text'"
                  :filter="existClient ? 'phone' : null"
                  :label="$t('Celular')"
                />
                <FormulateInput
                  v-else
                  id="pdv-tab-client-phone-mobile"
                  :value="stClientForm.mobilePhone"
                  name="cellphone"
                  type="label"
                  filter="phone"
                  :label="$t('Celular')"
                />
              </b-col>
            </b-row>
          </div>
        </transition>
      </b-card-actions>

      <transition name="fade">
        <div v-if="!isAnonymous">
          <b-card-actions :title="$t('Outros dados')" no-actions :show-loading="fetching">
            <b-row>
              <b-col>
                <FormulateInput
                  id="pdv-tab-client-observation"
                  v-model="stClientForm.observation"
                  name="observation"
                  :type="existClient ? 'label' : 'textarea'"
                  :label="$t('Observação')"
                  :placeholder="$t('Observação')"
                />
              </b-col>
            </b-row>

            <!-- variante entre fisica e juridica -->
            <template v-if="isNatural">
              <b-row>
                <b-col>
                  <FormulateInput
                    id="pdv-tab-client-birthdate"
                    v-model="stClientForm.birthdate"
                    name="birthdate"
                    :type="existClient ? 'label' : 'datepicker'"
                    :filter="existClient ? 'dateMask' : null"
                    :label="$t('Data de nascimento')"
                    :disabled="existClient"
                    :max="today"
                  />
                </b-col>
              </b-row>
            </template>

            <template v-if="isJuridical">
              <b-row class="align-items-center">
                <b-col
                  :md="!existClient ? '12' : isUpdating.name ? '8' : 'auto'"
                  class="d-flex align-items-center"
                >
                  <FormulateInput
                    id="pdv-tab-client-name"
                    ref="name"
                    v-model="stClientForm.name"
                    name="name"
                    :type="existClient && !isUpdating.name ? 'label' : 'text'"
                    :label="$t('Nome Fantasia')"
                    :placeholder="$t('Nome Fantasia')"
                    class="flex-grow-1"
                  />
                  <e-button
                    v-if="enableEdit('name')"
                    pill
                    class="edit-button ml-2"
                    variant="outline-secondary"
                    type="button"
                    icon="pencil"
                    :title="$t('Alterar \'Nome Fantasia\' do cliente')"
                    @click="ableToUpdate('name')"
                  />
                </b-col>
                <b-col v-if="isUpdating.name && stClientForm.id" class="actions pf-actions">
                  <e-button
                    title="Confirmar"
                    size="sm"
                    variant="primary"
                    icon="check-circle"
                    style="margin-right: 6px"
                    @click="updateCompanyNameOrName(stClientForm.name, 'name')"
                  />
                  <e-button
                    title="Cancelar"
                    size="sm"
                    variant="danger"
                    icon="x-circle"
                    @click="cancelUpdate('name')"
                  />
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <FormulateInput
                    id="pdv-tab-client-state-registration-type"
                    v-model="stClientForm.stateRegistrationType"
                    name="stateRegistrationType"
                    :type="existClient ? 'label' : 'vue-select'"
                    :label="$t('Indicador da IE')"
                    :placeholder="$t('Selecione')"
                    :options="indicatorIETypes()"
                  />
                </b-col>
                <b-col>
                  <FormulateInput
                    id="pdv-tab-client-state-registration"
                    v-model="stClientForm.stateRegistration"
                    name="stateRegistration"
                    :type="existClient ? 'label' : 'text'"
                    :filter="existClient ? 'rgIeMask' : null"
                    :label="$t('Inscrição estadual')"
                    maxlength="20"
                    :disabled="
                      [
                        indicatorIETypesEnum.EXEMPT_REGISTRATION,
                        indicatorIETypesEnum.NO_TAXPAYER,
                      ].includes(stClientForm.stateRegistrationType)
                    "
                  />
                </b-col>
              </b-row>
            </template>
          </b-card-actions>

          <!-- Seção de Recompensas -->
          <template v-if="existClient && stClientForm.id && stClientForm.id !== 1">
            <b-card-actions
              :title="$t('Programa ecash')"
              :show-loading="loadingRewardBalance"
              no-actions
            >
              <b-row v-if="rewardBalance !== null">
                <b-col>
                  <div class="d-flex align-items-center">
                    <i class="fa fa-gift text-success mr-2" />
                    <span class="font-weight-medium">{{ $t('Saldo ecash') }}:</span>
                    <b-badge
                      :variant="hasRewardBalance ? 'success' : 'secondary'"
                      class="ml-2 px-2 py-1"
                    >
                      {{ formatRewardBalance(rewardBalance) }}
                    </b-badge>
                  </div>
                  <small v-if="hasRewardBalance" class="text-muted">
                    {{ $t('O cliente pode usar este saldo para desconto na compra') }}
                  </small>
                </b-col>
              </b-row>
            </b-card-actions>
          </template>

          <!-- Seção Clube echope -->
          <template
            v-if="
              !isKioskStore && existClient && stClientForm.id && stClientForm.id !== 1 && isNatural
            "
          >
            <b-card-actions
              :title="$t('Clube echope')"
              :show-loading="loadingEchopeClubBalance"
              no-actions
            >
              <b-row class="align-items-center">
                <b-col>
                  <e-button
                    id="pdv-tab-client-btn-echope-club-balance"
                    variant="outline-primary"
                    :text="$t('Consultar saldo')"
                    icon="currency-dollar"
                    size="sm"
                    :busy="loadingEchopeClubBalance"
                    :disabled="!stClientForm.document"
                    @click="onConsultEchopeClubBalance"
                  />
                </b-col>
              </b-row>
              <b-row v-if="echopeClubBalance !== null" class="mt-1">
                <b-col>
                  <div class="d-flex align-items-center">
                    <i class="fa fa-star text-warning mr-2" />
                    <span class="font-weight-medium">{{ $t('Saldo Clube echope') }}:</span>
                    <b-badge
                      :variant="hasEchopeClubBalance ? 'success' : 'secondary'"
                      class="ml-2 px-2 py-1"
                    >
                      {{ echopeClubBalance.balance | currency }}
                    </b-badge>
                  </div>
                  <small v-if="hasEchopeClubBalance" class="text-muted">
                    {{ $t('O cliente pode usar este saldo como forma de pagamento') }}
                  </small>
                </b-col>
              </b-row>
            </b-card-actions>
          </template>

          <b-row>
            <b-col>
              <template v-if="existClient">
                <b-card-actions :title="$t('Endereço')" :show-loading="fetching" no-actions>
                  <e-address
                    v-model="stClientForm.address"
                    :required="false"
                    :show-loading="true"
                    :read-only="true"
                  />
                </b-card-actions>
              </template>
              <template v-else>
                <e-address
                  v-model="stClientForm.address"
                  :required="false"
                  :show-loading="fetching"
                />
              </template>
            </b-col>
          </b-row>
        </div>
      </transition>
    </b-container>

    <!-- Modal de Verificação de Código -->
    <reward-code-verification-modal
      ref="codeVerificationModal"
      :show-virtual-keyboard="false"
      :show-overlay-loading="true"
      @verified="onCodeVerified"
      @cancelled="onCodeVerificationCancelled"
    />
  </FormulateForm>
</template>

<script>
import _ from 'lodash'
import { BContainer, BRow, BCol, BAlert, BBadge } from 'bootstrap-vue'
import EAddress from '@/views/components/EAddress.vue'
import RewardCodeVerificationModal from '@/views/pages/pdv/atm/components/modals/RewardCodeVerificationModal.vue'
import {
  indicatorIETypes,
  personTypes,
  formulateHelper,
  payBoxPayments,
  keyboardCode,
  payBoxTypes,
} from '@/mixins'
import alerts from '@/mixins/alerts'
import BCardActions from '@/@core/components/b-card-actions/BCardActions.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import EButton from '@/views/components/EButton.vue'
import { validateBr } from 'js-brasil'
import { validatorFullName } from '@/@core/utils/validations/validators'
import axiosInstance from '@/libs/axios'
import { Shortcuts } from 'shortcuts'
import delegablePermissions from '@/utils/delegable-permissions'

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    EAddress,
    BCardActions,
    EButton,
    BBadge,
    BAlert,
    RewardCodeVerificationModal,
  },

  mixins: [
    indicatorIETypes,
    personTypes,
    formulateHelper,
    payBoxPayments,
    keyboardCode,
    alerts,
    payBoxTypes,
  ],

  data() {
    return {
      fetching: false,
      ecashVerificationLoading: false,
      pendingRewardAmount: undefined,
      shortcuts: new Shortcuts(),
      isUpdating: {
        companyName: false,
        name: false,
      },
      stateBeforeUpdate: {
        companyName: null,
        name: null,
      },
    }
  },

  computed: {
    ...mapState('app', ['modalAuthRef']),
    ...mapState('pages/pdv/payBox', {
      stClientForm: 'clientForm',
      paymentForm: 'paymentForm',
    }),
    ...mapGetters('pages/pdv/payBox', [
      'isOrder',
      'hasPalmBeerCustomer',
      'hasNewPalmBeerOperation',
      'hasCustomer',
      'hasRewardsApplied',
      'getTotalSale',
      'hasActivePayment',
      'salePriceTableId',
    ]),
    ...mapGetters('pages/pdv/payBoxTefRequestData', ['isTefCustomerDocumentWaiting']),
    ...mapGetters('pages/pdv/payBoxConfiguration', ['isTefRequestDataEnabled', 'isKioskStore']),
    ...mapState('reward', {
      rewardBalance: 'rewardBalance',
      loadingRewardBalance: 'loadingRewardBalance',
    }),
    ...mapGetters('reward', ['hasRewardBalance', 'formatRewardBalance']),
    ...mapState('echopeClub', {
      echopeClubBalance: 'echopeClubBalance',
      loadingEchopeClubBalance: 'loadingEchopeClubBalance',
    }),
    ...mapGetters('echopeClub', ['hasEchopeClubBalance']),

    today() {
      return new Date()
    },

    isCustomerLoading() {
      return this.fetching || this.isTefCustomerDocumentWaiting
    },
    showTefRequestDocument() {
      return this.isTefRequestDataEnabled && !this.hasCustomer
    },

    existClient() {
      return !!this.stClientForm.id
    },
    isDocumentFromTef() {
      return this.stClientForm.isDocumentFromTef
    },

    isNatural() {
      return this.stClientForm.personType === this.personTypeEnum.INDIVIDUAL
    },
    isJuridical() {
      return this.stClientForm.personType === this.personTypeEnum.JURIDICAL
    },
    isAnonymous() {
      return this.stClientForm.personType === this.personTypeEnum.CONSUMER
    },
  },

  methods: {
    ...mapActions('pages/pdv/payBox', {
      stSetClientForm: 'setClientForm',
      stCleanClientForm: 'cleanClientForm',
      stFetchClientByDocument: 'fetchClientByDocument',
      stcleanClientFormWithoutDocument: 'cleanClientFormWithoutDocument',
      stApplyRewards: 'applyRewards',
      stClearPayBoxRewardData: 'clearPayBoxRewardData',
    }),
    ...mapActions('pages/pdv/payBoxTefRequestData', {
      stTefRequestCustomerDocument: 'tefRequestCustomerDocument',
    }),
    ...mapActions('pages/pdv/payBoxStatus', {
      stSetStartFetchCustomer: 'setStartFetchCustomer',
      stSetFinishFetchCustomer: 'setFinishFetchCustomer',
    }),
    ...mapActions('reward', [
      'getCustomerRewardBalance',
      'confirmUseRewardBalance',
      'calculateRewardDiscount',
    ]),
    ...mapActions('echopeClub', ['fetchEchopeClubBalance', 'clearEchopeClubData']),

    enableEdit(companyNameOrName) {
      if (!this.existClient || this.stClientForm.id === 1 || this.isUpdating[companyNameOrName])
        return false

      const isFantasyName = this.isJuridical && companyNameOrName === 'name'

      const value = (this.stClientForm[companyNameOrName] || '').toString().toUpperCase().trim()

      const isValid = isFantasyName ? value : validatorFullName(value)

      const STATUS_TO_ABLE_TO_PATCH = ['NÃO INFORMADO', 'NAO INFORMADO']

      if (!STATUS_TO_ABLE_TO_PATCH.includes(value) && isValid) return false

      return true
    },

    ableToUpdate(field) {
      const { context } = this.$refs[field]

      this.stateBeforeUpdate[field] = context.model
      this.changeInputType(field)
    },

    async refreshCustomer() {
      const { document } = this.stClientForm

      try {
        this.fetching = true
        await this.stFetchClientByDocument(document)
      } catch (error) {
        this.showError({ error })
      } finally {
        this.fetching = false
      }
    },

    cancelUpdate(field) {
      this.changeInputType(field)
      this.$refs[field].context.model = this.stateBeforeUpdate[field]
    },

    changeInputType(field) {
      if (field === 'name') {
        this.isUpdating.name = !this.isUpdating.name
      } else {
        this.isUpdating.companyName = !this.isUpdating.companyName
      }
    },

    async updateCompanyNameOrName(textToUpdate, companyNameOrName) {
      const validationError = { message: '' }

      const trimmedText = (textToUpdate ?? '').trim()
      const isFantasyName = this.isJuridical && companyNameOrName === 'name'

      if (!trimmedText) {
        validationError.message = this.$t('PAY_BOX_SALE.CUSTOMER.ONLY_WHITE_SPACES')
        return this.showError({ message: validationError.message })
      }

      if (!validatorFullName(trimmedText) && !isFantasyName) {
        validationError.message = this.$t('PAY_BOX_SALE.CUSTOMER.INVALID_FULL_NAME')
        return this.showError({ message: validationError.message })
      }

      const payload = {
        id: this.stClientForm.id,
      }

      if (companyNameOrName === 'companyName') {
        payload.companyName = trimmedText
      } else {
        payload.name = trimmedText
      }

      try {
        await axiosInstance.patch('/api/sales/pay-box-customer/update-name', payload)
      } catch (error) {
        this.showError({ error })
        return null
      }

      this.changeInputType(companyNameOrName)
      this.onInputCustomerDocument()

      this.showSuccess({ message: this.$t('Campo atualizado com sucesso') })
      return null
    },

    onFocusDocument() {
      this.focusInput('#pdv-tab-client-document')
    },

    // eslint-disable-next-line func-names
    onInputCustomerDocument: _.debounce(async function (text) {
      if (!this.$refs.formClientTab) return
      await this.changePersonType(text)
      await this.onSearchCustomer()
    }, 500),

    async onSearchCustomer() {
      if (this.isOrder) return
      const { document } = this.stClientForm
      if (!validateBr.cpfcnpj(document || '')) {
        this.cleanClientWithoutDocument()
        return
      }

      const cleanedText = document.replace(/[./-]/g, '')
      try {
        this.fetching = true
        await this.stFetchClientByDocument(cleanedText)

        // Se cliente foi encontrado, buscar saldo de recompensas
        if (this.stClientForm.id && this.stClientForm.id !== 1) {
          await this.getCustomerRewardBalance(this.stClientForm.id)

          // Se tem saldo, perguntar se quer usar
          if (this.hasRewardBalance) {
            const useRewards = await this.confirmUseRewardBalance({
              $t: this.$t,
              confirm: this.confirm,
            })
            if (useRewards) {
              this.applyRewards()
            }
          }
        }
      } catch (error) {
        this.showError({ error })
      } finally {
        this.fetching = false
      }
    },

    async applyRewards() {
      if (await this.mxPayBoxActionIsBlocked(this.uiPayBoxActionsEnum.SALE_APPLY_REWARD)) {
        return
      }

      const customerChangeValidated = await this.validateCustomerChanges()
      if (customerChangeValidated.hasError) {
        this.showWarning({
          message: this.$t(customerChangeValidated.message),
        })
        return
      }

      const allowedRewardsAmount = await this.calculateRewardDiscount({
        customerId: this.stClientForm.id,
        saleTotal: this.getTotalSale,
        priceTableId: this.salePriceTableId,
      })
      if (allowedRewardsAmount < this.rewardBalance?.currentBalance) {
        this.showInformation({
          title: this.$t('Limite excedido'),
          text: `O valor máximo de ecash que pode ser aplicadas nesta venda é de ${this.$options.filters.currency(
            allowedRewardsAmount
          )}`,
        })
      }

      if (!this.stClientForm.emailAccess) {
        await this.showInformation({
          title: this.$t('Cadastro incompleto'),
          text: 'Para resgatar as recompensas, baixe o app da echope e complete seu cadastro.',
        })
      } else {
        // Guardar o valor permitido e mostrar o modal de verificação
        this.pendingRewardAmount = allowedRewardsAmount
        this.ecashVerificationLoading = true
        await this.$refs.codeVerificationModal.show(this.stClientForm.id, this.getTotalSale)
      }
    },

    async onCodeVerified() {
      try {
        // Aplicar o desconto após validação bem-sucedida
        if (this.pendingRewardAmount !== undefined) {
          await this.stApplyRewards(this.pendingRewardAmount)
        }
      } catch (error) {
        this.showError({ error })
      } finally {
        this.ecashVerificationLoading = false
        this.pendingRewardAmount = undefined
      }
    },

    onCodeVerificationCancelled() {
      this.ecashVerificationLoading = false
      this.pendingRewardAmount = undefined
    },

    async removeRewards() {
      if (await this.mxPayBoxActionIsBlocked(this.uiPayBoxActionsEnum.SALE_REMOVE_REWARD)) {
        return
      }

      const customerChangeValidated = await this.validateCustomerChanges()
      if (customerChangeValidated.hasError) {
        this.showWarning({
          message: this.$t(customerChangeValidated.message),
        })
        return
      }

      await this.stApplyRewards(0)
    },

    async onRequestDocument() {
      if (!this.showTefRequestDocument || this.isCustomerLoading) return

      if ((this.stClientForm.document || '').trim()) {
        this.showWarning({
          message: this.$t(
            'Necessário limpar os dados na aba cliente para solicitar o documento pelo PinPad'
          ),
        })
        return
      }

      await this.stTefRequestCustomerDocument()
    },

    async changePersonType(text) {
      const { CONSUMER, INDIVIDUAL, JURIDICAL } = this.personTypeEnum
      const data = { personType: this.stClientForm.personType }
      const cleanedText = text?.replace(/[./-]/g, '') || ''

      try {
        await this.stSetStartFetchCustomer()

        if (cleanedText.length < 11) {
          data.personType = CONSUMER
          await this.stSetClientForm(data)
          return
        }

        if (cleanedText.length === 11) {
          data.personType = INDIVIDUAL
        } else {
          data.personType = JURIDICAL
        }
        await this.stSetClientForm(data)
      } finally {
        await this.stSetFinishFetchCustomer()
      }
    },

    async onCleanForm() {
      if (await this.mxPayBoxActionIsBlocked(this.uiPayBoxActionsEnum.CUSTOMER_REMOVE)) {
        return
      }

      const customerChangeValidated = await this.validateCustomerChanges()
      if (customerChangeValidated.hasError) {
        this.showWarning({
          message: this.$t(customerChangeValidated.message),
        })
        return
      }

      this.$formulate.resetValidation('formClientTab')
      await this.stCleanClientForm()
      this.isUpdating.companyName = false
      this.isUpdating.name = false
      await this.stClearPayBoxRewardData()
      this.clearEchopeClubData()
    },

    async onConsultEchopeClubBalance() {
      if (!this.stClientForm.document) {
        this.showWarning({
          message: this.$t('Informe o CPF do cliente antes de consultar o saldo.'),
        })
        return
      }
      try {
        await this.modalAuthRef.auth(delegablePermissions.PDV_ECHOPE_CLUB_BALANCE)
      } catch (error) {
        // autorização cancelada ou negada
        this.showWarning({
          message: this.$t('Você não tem permissão para consultar o saldo do Clube echope.'),
        })
        return
      }
      try {
        await this.fetchEchopeClubBalance(this.stClientForm.id)
        if (this.echopeClubBalance === null) {
          this.showInformation({
            title: this.$t('Clube echope'),
            text: this.$t('Nenhum saldo encontrado para este cliente.'),
          })
        }
      } catch (error) {
        this.showError({ error })
      }
    },

    cleanClientWithoutDocument() {
      this.stcleanClientFormWithoutDocument()
      this.stClearPayBoxRewardData()
      this.clearEchopeClubData()
    },

    startCustomerTabShortcut() {
      this.shortcuts.add([
        {
          shortcut: this.keyCode.f8,
          handler: () => {
            this.onRequestDocument()
            return true
          },
        },
      ])
    },

    endCustomerTabShortcut() {
      this.shortcuts.reset()
    },

    async validateCustomerChanges() {
      const validationResult = {
        hasError: false,
        message: '',
      }

      if (this.hasActivePayment) {
        return {
          hasError: true,
          message: 'Há pagamento ativo na venda. Cancele os pagamentos primeiro para continuar.',
        }
      }

      return validationResult
    },

    validate() {
      this.$refs.formClientTab.showErrors()
      if (this.hasNewPalmBeerOperation && !this.existClient) {
        return false
      }

      return this.$refs.formClientTab.isValid
    },
  },
}
</script>

<style scoped>
.tab-container {
  display: flex;
  flex-flow: column nowrap;
  gap: 10px;
  height: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: 0.2s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(-20px);
}

.opacity-enter-active,
.opacity-leave-active {
  transition: 0.5s;
}

.opacity-enter,
.opacity-leave-to

/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.edit-button {
  padding: 9px 5px;
}

.actions {
  margin-top: 0.5rem;
}

.pf-actions {
  margin-top: 1.5rem;
}

.refresh-button {
  padding: 9px 5px;
}

.refresh-button:focus,
.refresh-button:active {
  background-color: transparent !important;
  box-shadow: none !important;
}
</style>
